<template>
    <!-- 服务号引导卡片 -->
    <div
        v-if="qrcodeUrl"
        class="service-guide-card"
        :class="{'overlay': isOverlay}"
    >
        <div class="guide-card">
            <div v-if="title" class="header">
                <p class="title">{{ title }}</p>
                <img
                    class="close-icon"
                    src="https://lvlin-sp-saas.cdn.bcebos.com/static%2Fstatic%2Fclose-icon.png"
                    @click="$emit('close', 'cancle')"
                />
            </div>
            <div class="service-card">
                <div v-if="subscription" class="service-card-text">
                    <div class="service-card-content">
                        <p class="subscription subscription-1">
                            <span class="subscription-title">百度APP通知：</span>
                            <span
                                class="result-status"
                                :style="{color: baiduBound ? '#00D154' : '#FF5722'}"
                            >{{ baiduBound ? '已开启' : '未绑定' }}</span>
                        </p>
                        <p class="subscription subscription-2">
                            <span class="subscription-title">微信服务号订阅：</span>
                            <span
                                class="result-status"
                                :style="{color: wechatBound ? '#00D154' : '#FF5722'}"
                            >{{ wechatBound ? '已开启' : '未绑定' }}</span>
                        </p>
                        <p class="tip">{{ tip }}</p>
                    </div>
                    <p class="hint">微信扫描右侧二维码，一键订阅</p>
                </div>
                <div v-else class="service-card-text">
                    <div class="service-card-content">
                        <p class="content-title">订阅微信服务号</p>
                        <p class="content-desc">{{ desc }}</p>
                        <p class="tip">{{ tip }}</p>
                    </div>
                    <p class="hint">微信扫描右侧二维码，一键订阅</p>
                </div>
                <!-- 二维码 -->
                <div
                    class="qrcode-container"
                    :class="subscription ? 'subscription-qrcode' : 'authentication-qrcode'"
                >
                    <div class="qrcode-img">
                        <img v-show="qrcodeUrl" :src="qrcodeUrl"/>
                    </div>
                    <p class="qrcode-content">
                        <span class="qrcode-content-text">法行宝律师服务号</span>
                        <span
                            v-if="!subscription"
                            class="result-status result-status-unbound"
                        >未绑定</span>
                    </p>
                </div>
            </div>
            <div class="btn" @click="$emit('close', 'ok')">我知道了</div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'ServiceGuideCard',
    props: {
        isOverlay: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        tip: {
            type: String,
            default: '审核结果1-3个工作日告知您'
        },
        baiduBound: {
            type: Number,
            default: 0
        },
        wechatBound: {
            type: Number,
            default: 0
        },
        // 是否展示订阅结果卡片
        subscription: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            qrcodeUrl: state => state.lawStore.qrcodeUrl
        })
    }
};
</script>

<style lang="less" scoped>
.service-guide-card {
    .guide-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 490px;
        padding: 25px 30px;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 0 10px rgba(196, 196, 196, .5);

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 13px;

            .title {
                color: #1e1f24;
                font-family: "PingFang SC";
                font-size: 18px;
                font-weight: bold;
            }

            .close-icon {
                width: 18px;
                height: 18px;
            }
        }

        .service-card {
            width: 430px;
            background: linear-gradient(346.1deg, rgba(0, 174, 254, .53) 5.94%, #0061fe 99.02%);
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            display: flex;
            justify-content: space-between;
            padding: 20px 24px;
            z-index: -2;

            .service-card-text {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .subscription {
                width: 203px;
                font-family: "PingFang SC";
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;

                .subscription-title {
                    color: #fff;
                    font-size: 18px;
                    line-height: 18px;
                    font-weight: bold;
                }

                .result-status {
                    width: 54px;
                    height: 22px;
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    background: #fff;
                }
            }

            .subscription-2 {
                margin-bottom: 14px;
            }

            .content-title {
                font-family: "PingFang SC";
                font-size: 22px;
                line-height: 22px;
                color: #fff;
                font-weight: bold;
                margin-bottom: 10px;
            }

            .content-desc {
                font-size: 26px;
                line-height: 26px;
                font-family: "PingFang SC";
                font-weight: bold;
                color: #fff6b1;
                margin-bottom: 15px;
                position: relative;
                z-index: 1;
            }

            .content-desc::after {
                content: " ";
                position: absolute;
                left: 0;
                bottom: -6px;
                background-image: url("https://lvlin-sp-saas.cdn.bcebos.com/static/static/service-guide-highlight.png");
                background-repeat: no-repeat;
                background-position: left bottom;
                width: 100%;
                height: 100%;
                z-index: -1;
            }

            .tip {
                font-size: 14px;
                padding: 8px 10px;
                background: #fff;
                color: #076afe;
                border-radius: 2px 8px 8px 8px;
            }

            .hint {
                font-family: "PingFang SC";
                font-size: 14px;
                line-height: 14px;
                color: #fff;
            }

            .qrcode-container {
                width: 139px;
                border-radius: 6px;
                border: 1px solid #e3e3e3;
                background: #fff;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                overflow: hidden;

                .qrcode-img {
                    width: 127px;
                    height: 127px;
                    flex-shrink: 0;
                    border-radius: 6px;
                    overflow: hidden;
                    margin-top: 6px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .qrcode-content {
                    color: #848691;
                    font-family: "PingFang SC";
                    font-size: 14px;
                    line-height: 14px;

                    span {
                        display: block;
                    }

                    .result-status {
                        color: #fd503e;
                        font-size: 14px;
                    }
                }
            }

            .subscription-qrcode {
                height: 152px;
                padding: 6px 0 16.5px 0;
            }

            .authentication-qrcode {
                height: 182px;
                padding: 6px 0 10.5px 0;
            }

            .result-status-unbound {
                margin-top: 6px;
                color: #fd503e;
            }
        }

        .service-card::after {
            content: " ";
            position: absolute;
            left: 0;
            top: 0;
            background-image: url("https://lvlin-sp-saas.cdn.bcebos.com/static/static/service-guide-bg.png");
            background-repeat: no-repeat;
            background-position: left top;
            background-size: 100%;
            width: 430px;
            height: 100%;
            z-index: -1;
        }

        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 104px;
            height: 36px;
            border-radius: 4px;
            background: #05f;
            color: #fff;
            margin-top: 24px;
        }
    }
}

.overlay {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
}
</style>
